/** Minimum time (ms) to show the loading screen before hiding it. */
export const MIN_LOADING_MS = 500;

/**
 * Schedules setLoading(false) so that loading is shown for at least MIN_LOADING_MS
 * from the given startTime. Call with the timestamp from when loading was set to true.
 */
export function scheduleLoadingEnd(
  startTime: number,
  setLoading: (value: boolean) => void,
  minMs: number = MIN_LOADING_MS
): void {
  const elapsed = Date.now() - startTime;
  const remaining = Math.max(0, minMs - elapsed);
  if (remaining > 0) {
    setTimeout(() => setLoading(false), remaining);
  } else {
    setLoading(false);
  }
}
